import { SignedOutHeader } from "@/components/navigation/SignedOutHeader";
import { NavigationStackProvider } from "@/contexts/NavigationStackContext";
import { ScrollContainerProvider } from "@/contexts/ScrollContainerContext";
import ScrollContainer from "@/components/layout/ScrollContainer";
import { StackedRouter } from "@/components/navigation/StackedRouter";
import { useAuth } from "@/contexts/AuthContext";
import { getAdminBackup } from "@/hooks/useCanImpersonate";
import { useStatusTapScrollToTop } from "@/hooks/app/useStatusTapScrollToTop";
import { useSearchParams } from "react-router-dom";
import { MenuProvider } from "@/features/navigation/MenuContext";
import { MenuLayout } from "@/features/navigation/MenuLayout";
import { LABEL } from "@/lib/typography";
import { cn } from "@/lib/utils";

// Must render inside ScrollContainerProvider to see the active container.
const StatusTapScrollToTop = () => {
  useStatusTapScrollToTop();
  return null;
};

const GatedUserBanner = () => {
  const { user } = useAuth();
  const isImpersonating = !!getAdminBackup();

  if (!isImpersonating || user?.is_gated !== true) return null;

  return (
    <div className="fixed bottom-[calc(var(--above-bottom-nav)+1rem)] left-4 right-4 z-50 rounded-xl border bg-amber-50/95 dark:bg-amber-950/80 backdrop-blur-sm border-amber-200 dark:border-amber-900/50 px-4 py-1.5 text-center desktop:static desktop:inset-auto desktop:z-auto desktop:rounded-none desktop:border-x-0 desktop:border-t-0 desktop:bg-amber-50 desktop:dark:bg-amber-950/30 desktop:backdrop-blur-none desktop:py-2">
      <span className={cn(LABEL, "text-amber-900 dark:text-amber-100")}>
        This user is on the waitlist (gated)
      </span>
    </div>
  );
};

export const AppShell = () => {
  const [searchParams] = useSearchParams();
  const isEmbed = searchParams.get("embed") === "1";
  const { isAuthenticated } = useAuth();
  // Signed in, navigation is the menu (drawer), as natively. Signed-out visitors
  // to public stashes, stuff and collections keep the header and its sign-up.
  const withMenu = isAuthenticated && !isEmbed;
  const page = (
    <main className="h-full min-h-0 overflow-hidden">
      <StackedRouter />
    </main>
  );

  return (
    <NavigationStackProvider>
      <MenuProvider>
        <ScrollContainerProvider>
          <StatusTapScrollToTop />
          <ScrollContainer
            isActive
            className="flex h-dvh flex-col bg-background overflow-hidden"
          >
            {!isEmbed && !isAuthenticated && (
              <div className="hidden desktop:block">
                <SignedOutHeader />
              </div>
            )}
            {!isEmbed && <GatedUserBanner />}
            {withMenu ? <MenuLayout>{page}</MenuLayout> : <div className="min-h-0 flex-1">{page}</div>}
          </ScrollContainer>
        </ScrollContainerProvider>
      </MenuProvider>
    </NavigationStackProvider>
  );
};

export default AppShell;
